import { render, staticRenderFns } from "./ModalPriceList.vue?vue&type=template&id=584ac072&scoped=true"
import script from "./ModalPriceList.vue?vue&type=script&lang=js"
export * from "./ModalPriceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584ac072",
  null
  
)

export default component.exports